export * as PlatformUtils from './platform';
export * as AxiosUtils from './axios';
export * as NumberUtils from './number';
export * as BooleanUtils from './boolean';
export * as DateUtils from './date';
export * as FormikUtils from './formik';
export * as ApiUtils from './api';
export * as FileUtils from './files';
export * as EnumUtils from './enum';
export * as MatchingUtils from './matching';
export * as HtmlUtils from './html';
export * as ArrayUtils from './array';

export function NotNull<TValue>(value: TValue | null | undefined): value is TValue {
	return value != null;
}
